// eslint-disable-next-line
export default 'staging';
